import { useParams } from "react-router-dom";
import "./style.css"
import { Helmet } from "react-helmet-async";
import { useEffect, useRef, useState } from "react";
import { Heart, Trash } from "react-feather";
import Spinner, { LoadingThreeCircle } from "../../../global-components/src/components/spinner/spiner";
import { LIMIT_REQUEST_COMMENTS } from "../../../utils/vars";
import { useAuth } from "../../../global-components/src";
import axios from "axios";
import { Post as PostType } from "../../../types";
import { PACOCA_API_URL } from "../../../global-components/src/utils/vars";
import UserSearch from "../../../pages/Settings/SearchScreen/User/User";
import PostLikesContent from "./post-likes-content";
import BottomSheet from "../../bottom-sheet/bottom-sheet";

interface ModalPostLikesBottomProps {
    idPostSelected: number | null; // Define que posts é um array de Post
    open: boolean;
    setOpen: (val: boolean) => void;
}

const ModalPostLikesBottom: React.FC<ModalPostLikesBottomProps> = ({ open, setOpen, idPostSelected }) => {
    // impede de voltar tela ao clicar em voltar com modal aberto
    useEffect(() => {
        if(open) window.history.pushState({ isModal: true }, "");
        else window.history.pushState({ isModal: false }, "");
    }, [open]);
    useEffect(() => {
        const handlePopState = (event: any) => {
            if (open) {
                setOpen(false); // Fecha o modal se o usuário voltou
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [open]);

    return (
        <BottomSheet 
            snapPoints={[0, .5, 1]} 
            initialSnap={1} 
            setOpen={setOpen} 
            open={open}
            title={
                <h4 id="modal-title-bottom">Curtidas</h4>
            }
        >
            <div className="modal-light modal-dialog modal-dialog-likes modal-dialog-centered cover-mobile" role="document">
                <div className="modal-content modal-content-likes" id="modal-content-likes">
                    <div className="modal-body modal-body-likes overflow-minus">
                        <PostLikesContent open={open} idPostSelected={idPostSelected}/>
                    </div>
                </div>
            </div>

        </BottomSheet>
    );
};

export default ModalPostLikesBottom;
